module.exports = __webpack_public_path__ + "img/screen-participants-dark-es.94ebed30.png";